window.addEventListener('scroll', () => {
  const indicator = document.getElementById('scroll-indicator');
  const scrollTop = document.documentElement.scrollTop;
  const scrollHeight =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  const progress = scrollTop / scrollHeight;
  indicator.style.setProperty('--progress', progress);
});
